import { NgModule, DoBootstrap, Injector, enableProdMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '@app/app-routing.module';
import { AppComponent } from '@app/app.component';
import { createCustomElement } from '@angular/elements';
import { GetListComponent } from './shared/utils/getWebComponents';
import { RouterModule } from '@angular/router';
import { FeatherModule } from 'angular-feather';
import { allIcons } from 'angular-feather/icons';
import { MarkdownModule } from 'ngx-markdown';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './modules/material/material.module';
import { CodeInputModule } from 'angular-code-input';
import { environment } from '@environments/environment';

if (environment.production) {
  enableProdMode();
}

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FeatherModule.pick(allIcons),
    MarkdownModule.forRoot(),
    MaterialModule,
    CodeInputModule,
  ],
  providers: [],
  declarations: [AppComponent],
  bootstrap: []
})
export class AppModule implements DoBootstrap {
  constructor(private injector: Injector) {}

  createWebComponent(name: string, component: any) {
    const customComponent = createCustomElement(component, {
      injector: this.injector,
    });
    customElements.define(name, customComponent);
  }

  ngDoBootstrap() {
    GetListComponent.map((component) =>
      this.createWebComponent(component.name, component.component)
    );
  }
}
